import { useQuery, useMutation, useQueryClient } from "@tanstack/react-query"
import {
  getErrorCodesMappings,
  getErrorCodesMapping,
  createErrorCodesMapping,
  updateErrorCodesMapping,
  deleteErrorCodesMapping,
} from "../api/errorCodesMappings"

export const useErrorCodesMappingsData = ({ page, limit, filters }) =>
  useQuery({
    queryKey: ["error-codes-mappings", page, limit, filters],
    queryFn: () => getErrorCodesMappings({ page, limit, filters }),
    retry: false,
  })

export const useErrorCodesMapping = (errorId) =>
  useQuery({
    queryKey: ["error-codes-mapping", errorId],
    queryFn: () => getErrorCodesMapping(errorId),
    retry: false,
    enabled: !!errorId,
  })

export const useCreateErrorCodesMapping = () => {
  const queryClient = useQueryClient()

  return useMutation({
    mutationFn: createErrorCodesMapping,
    onSuccess: () => {
      queryClient.invalidateQueries({ queryKey: ["error-codes-mappings"] })
    },
  })
}

export const useUpdateErrorCodesMapping = () => {
  const queryClient = useQueryClient()

  return useMutation({
    mutationFn: ({ errorId, data }) => updateErrorCodesMapping(errorId, data),
    onSuccess: () => {
      queryClient.invalidateQueries({ queryKey: ["error-codes-mappings"] })
      queryClient.invalidateQueries({ queryKey: ["error-codes-mapping"] })
    },
  })
}

export const useDeleteErrorCodesMapping = () => {
  const queryClient = useQueryClient()

  return useMutation({
    mutationFn: deleteErrorCodesMapping,
    onSuccess: () => {
      queryClient.invalidateQueries({ queryKey: ["error-codes-mappings"] })
    },
  })
}
